<template>
  <div v-if="isVisibleModal" class="commerce-connect-cta-pane__modal">
    <div class="commerce-connect-cta-pane__modal__backdrop" @click="onClick()" />
    <div class="commerce-connect-cta-pane__modal__container">
      <button
        type="button"
        name="button"
        :aria-label="ariaLabelClose"
        class="commerce-connect-cta-pane__modal__close"
        @click="onClick()"
      />
      <div class="commerce-connect-cta-pane__modal__body">
        <div class="commerce-connect-cta-pane">
          <div class="tabs-details">
            <h2 class="commerce-connect-cta-pane__headline">
              {{ commerceOnlineTitle }}
            </h2>
            <ul v-if="onlineShops.length" class="commerce-connect-cta-pane__btn-list">
              <li
                v-for="(shop, index) in onlineShops"
                :key="index"
                class="commerce-connect-cta-pane__item"
              >
                <a
                  :class="[
                    'commerce-connect-cta-pane__item-wrapper',
                    { 'commerce-connect-cta-pane__item-wrapper--no-logo': '' },
                  ]"
                  :title="shop.Name"
                  :href="getRetailerDetails(shop)"
                  target="_blank"
                >
                  <img
                    class="commerce-connect-cta-pane__item-logo"
                    :src="getRetailerDetails(shop, false)"
                    :alt="shop.Name"
                  />
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'commerce-connect-cta-modal',
  props: {
    commercePopupData: {
      type: Object,
      required: true,
    },
    commerceOnlineTitle: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isVisibleModal: false,
      onlineShops: [],
    };
  },
  mounted() {
    window.eventBus.$on('commerceConnectButtonModal', () => {
      this.fetchData();
      this.isVisibleModal = true;
    });
  },
  beforeDestroy() {
    this.disableOverflow(false);
  },
  methods: {
    fetchData: function () {
      function get(obj, path) {
        for (let i = 0; i < path.length; i++) {
          if (!obj || typeof obj !== 'object') return null;
          obj = obj[path[i]];
        }
        return obj;
      }
      let result = get(this.commercePopupData, ['getResult', 0, 'ResultGroups', 0, 'OnlineShops']);
      this.onlineShops = result || [];
    },
    onClick() {
      this.isVisibleModal = false;
      this.disableOverflow(false);
    },
    disableOverflow(value = true) {
      document.documentElement.style.overflow = value ? 'hidden' : 'auto';
    },
    getRetailerDetails(retailerDetails, getSource = true) {
      if (!retailerDetails) return '';

      function getDeep(obj, pathArr) {
        return pathArr.reduce(function (acc, key) {
          return acc && acc[key] !== undefined ? acc[key] : null;
        }, obj);
      }

      if (getSource) {
        return getDeep(retailerDetails, ['OfferInfo', 'Offers', 0, 'Deeplink']) || '';
      }

      const logo = getDeep(retailerDetails, ['Logos', 0, 'LogoMedium']);
      return logo ? 'https://' + logo : '';
    },
  },
};
</script>
